import { OptoColors } from '@/config/settings';
import type { FishGroupTransferOperationType } from '@/domain/fishGroups';

/**
 * Mapping from a transfer operation type to the color used for its edge
 * stroke and arrow marker in the lineage DAG. The same palette feeds the
 * legend swatches, so any change here is reflected automatically.
 *
 * The four entries map 1:1 to the operation types that can produce a
 * transfer row (creation/relocation/closure/discard never appear here).
 */
export const LINEAGE_EDGE_COLORS: Record<FishGroupTransferOperationType, OptoColors> = {
    split: OptoColors.OceanGreen,
    merge: OptoColors.Riverside,
    split_and_merge: OptoColors.Purple,
    redistribution: OptoColors.Orange,
};

export function colorForOperationType(operationType: FishGroupTransferOperationType): string {
    return LINEAGE_EDGE_COLORS[operationType];
}
